<ng-container *transloco="let t">
  @let enabled = $safeNavigationMigration(examinationForms?.length) > 1;
  <button
    appearance="flat"
    class="w-full whitespace-normal! rounded-none! px-4! text-text-primary!"
    data-testid="selector"
    size="m"
    tuiButton
    tuiChevron
    type="button"
    [ngClass]="{
      'pointer-events-none [&::after]:hidden!': !enabled,
    }"
    [tuiDropdown]="dropdownContent"
    [(tuiDropdownOpen)]="open">
    <span class="line-clamp-1 w-full text-left">
      {{ selectedExaminationForm?.title }}
    </span>
    <ng-template #dropdownContent>
      <tui-data-list class="max-w-xs">
        @for (examinationForm of examinationForms; track examinationForm.id) {
          <label class="flex gap-1" tuiOption>
            <span class="w-full truncate">
              {{ examinationForm?.title }}
            </span>
            <input
              class="hidden"
              type="radio"
              [ngModel]="selectedExaminationForm"
              [value]="examinationForm"
              (ngModelChange)="select($event)" />
            @if (selectedExaminationForm?.id === examinationForm.id) {
              <tui-icon icon="@tui.check" />
            }
          </label>
        }
      </tui-data-list>
    </ng-template>
  </button>
</ng-container>
